import React, { FC } from 'react';
import translate from '@translate';
import Dialog from 'src/components/Dialog';
import Grid, { GridItem } from 'src/components/Grid';
import Typography from '../../components/Typography';

export interface ColumnOptionsProps {
    onClose: () => void;
}

const ColumnOptions: FC<ColumnOptionsProps> = (props) => {
    return (
        <Dialog
            maxWidth="md"
            title={translate('ordersImport.columnsOptions')}
            onClose={props.onClose}
            sx={{
                paddingBottom: 0,
                '& .MuiDialogTitle-root': { paddingBottom: 0 },
                '& .MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2': { marginTop: 0 },
            }}
        >
            <Grid>
                <GridItem cols={12}>
                    <Typography variant="body1">
                        <strong>STATUS:</strong> {translate('ordersImport.tooltip.status')}
                    </Typography>
                </GridItem>
                <GridItem cols={12}><p></p></GridItem>
                <GridItem cols={12}>
                    <Typography variant="body1">
                        <strong>COUNT_PRODUCT:</strong> {translate('ordersImport.tooltip.countProduct')}
                    </Typography>
                </GridItem>
                <GridItem cols={12}><p></p></GridItem>
                <GridItem cols={12}>
                    <Typography variant="body1">
                        <strong>ADDRESS_ID:</strong> {translate('ordersImport.tooltip.addressId')}
                    </Typography>
                </GridItem>
                <GridItem cols={12}><p></p></GridItem>
                <GridItem cols={12}>
                    <Typography variant="body1">
                        <strong>BRANCH_ID:</strong> {translate('ordersImport.tooltip.branchId')}
                    </Typography>
                </GridItem>
                <GridItem cols={12}><p></p></GridItem>
                <GridItem cols={12}>
                    <Typography variant="body1">
                        <strong>PRICE:</strong> {translate('ordersImport.tooltip.price')}
                    </Typography>
                </GridItem>
            </Grid>
        </Dialog>
    );
};

export default ColumnOptions;
